<template>
  <span class="status-pill" :class="statusClassObject" :style="{background: statusColor}">
    {{statusFormatted}}
  </span>
</template>


<script>

// This is the list of statuses and the labels to use (not localized)
const STATUS_LEVELS = [
  {
    name: "available",
    label: "available",
    status: ["AVAILABLE"],
    colors: ["#45b854", "#128521"],
    in_legend: true
  },
  {
    name: "in use",
    label: "in use",
    status: ["IN_USE", "ALMOST_DONE", "DOOR_OPEN", "LUCKY_CYCLE", "READY_TO_START", "RESERVED"],
    colors: ["#f3a537", "#c07204"],
    in_legend: true
  },
  {
    name: "complete",
    label: "complete",
    status: ["COMPLETE"],
    colors: ["#2a8bda", "#0058a7"],
    in_legend: true
  },
  {
    name: "error",
    label: "error",
    status: ["ERROR"],
    colors: ["#D0011B", "#a90015"],
    in_legend: true
  },
  {
    name: "offline",
    label: "offline",
    status: ["DEFAULT", "UNKNOWN", "NETWORK_ERROR", "UNAVAILABLE"],
    colors: ["#c6cccf", "#93999c"],
    in_legend: true
  }
];

export default {
  name: "StatusPill",
  props: {
    status: String,
    themeConfig: Object,
  },
  data() {
    return {
      statusClassObject: {}
    };
  },
  computed: {
    statusFormatted() {
      const status = (this.status === undefined) ? "OFFLINE" : this.status.toUpperCase();
      let statusObj;
      let statusLevels;

      // Fallback to defaults if themeConfig is missing what we need
      if (this.themeConfig && this.themeConfig.status) {
        statusLevels = this.themeConfig.status;
      } else {
        statusLevels = STATUS_LEVELS
      }

      statusObj = statusLevels.find(item => {
        return item.status.includes(status);
      });

      let statusLabel = (statusObj && statusObj.label) ? statusObj.label : "offline"; // Use .label as the text
      let statusName = (statusObj && statusObj.name) ? statusObj.name : "offline"; // Use .name as the class name

      this.statusClassObject = {};
      this.statusClassObject[`${statusName.replace(' ', '_')}`] = true;

      return statusLabel;
    },

    statusColor() {
      let currentStatus = this.status;
      let themeConfig = this.themeConfig;

      // Return status colors defined in theme.json -or- defaultColors -or- fallbackColors
      if (currentStatus !== undefined) {
        currentStatus = currentStatus.toUpperCase();
      } else {
        currentStatus = "UNKNOWN";
      }

      const fallbackColors = ["#c6cccf", "#999d9e"];
      let statusList;

      if (themeConfig.status) {
        statusList = themeConfig.status;
      } else {
        statusList = STATUS_LEVELS;
      }

      function findStatusColor(currentStatus, statusList) {
        return statusList.find(item => {
          return item.status.includes(currentStatus);
        });
      }

      // Return the correct status to use
      if (findStatusColor(currentStatus, statusList)) {
        return findStatusColor(currentStatus, statusList).colors[0];
      }
      if (findStatusColor("DEFAULT", statusList)) {
        return findStatusColor("DEFAULT", statusList).colors[0];
      }
      return fallbackColors[0];
    }
  }
};
</script>

<style>
.status-pill {
  background: red;
  text-transform: capitalize;
  display: inline-block;
  padding: 0.125em 0.5em 0;
  color: white;
  border-radius: 4px;
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/machine/StatusPill.vue